import React, { useEffect } from 'react'
import { reverse } from 'named-urls'
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import { useHistory } from 'react-router-dom'

import { Label } from 'components'

import useDocumentGenerate from 'hooks/useDocumentGenerate'
import useClipboard from 'hooks/useClipboard'

import useStyles from './styles'
import { routes } from 'Routes'
import constants from 'constants/index'
import checkCircleImage from 'images/check-circle.svg'

const ConclusionStep = () => {
  const classes = useStyles()
  const history = useHistory()

  const {
    controlOriginPath,
    documentGenerated,
    disabledNextButton,
    setDisabledNextButton,
    wantsToAdvanceStep,
    setNextButtonText,
    resetNextButtonText,
  } = useDocumentGenerate()
  const { copy } = useClipboard()

  const isPublicDocumentAndHasLink =
    documentGenerated?.publicDocument && documentGenerated?.generateDocumentLink

  const handleCopy = () => {
    copy(documentGenerated?.generateDocumentLink)
  }

  const handleNextRedirect = () => {
    // Quando a criação começou por um controle do Projeto de Governança, o usuário volta para a
    // atividade de origem — é lá que ele vê o documento já vinculado como evidência.
    if (controlOriginPath) return history.push(controlOriginPath)

    if (documentGenerated?.collectAccepted) {
      return history.push({
        pathname: reverse(routes.documents.edit, {
          documentId: documentGenerated?.id,
        }),
        search: `?tab=${constants.documents.ACCEPTED_DOCUMENTS_CATEGORY_ID}`,
      })
    }

    history.push(routes.documents.all)
  }

  useEffect(() => {
    if (disabledNextButton) setDisabledNextButton(false)

    if (controlOriginPath) {
      setNextButtonText('Voltar para o controle')
    } else {
      setNextButtonText(
        documentGenerated?.collectAccepted
          ? 'Ir para aceites'
          : 'Ir para documentos',
      )
    }

    return () => {
      resetNextButtonText()
    }
  }, [])

  useEffect(() => {
    if (wantsToAdvanceStep) handleNextRedirect()
  }, [wantsToAdvanceStep])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="center" mt={2}>
          <img src={checkCircleImage} alt="Success" height={100} />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h2" align="center">
          Documento criado com sucesso
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Alert severity="success" className={classes.alert} icon={false}>
          <AlertTitle>Documento gerado com sucesso.</AlertTitle>
          <Typography>
            Seu documento foi gerado e armazenado na plataforma, com os demais
            documentos da organização.&nbsp;
            {isPublicDocumentAndHasLink &&
              'Seu link direto para o documento foi gerado.'}
          </Typography>
        </Alert>
      </Grid>

      {isPublicDocumentAndHasLink && (
        <Grid item xs={12}>
          <Label
            title="Link para o documento"
            description="Utilize o link abaixo para compartilhar seu documento com os usuários"
            paddingBoxTitle={0}
          >
            <TextField
              id="copy-field"
              label="Link para o documento"
              value={documentGenerated?.generateDocumentLink || ''}
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCopy}
                    >
                      Copiar
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Label>
        </Grid>
      )}

      <Grid item xs={12}>
        <Alert severity="info" icon={false}>
          <Typography>
            Caso tenha optado por <strong>Coletar aceites</strong> na etapa
            anterior, você poderá configurá-los na próxima tela.
          </Typography>
        </Alert>
      </Grid>
    </Grid>
  )
}

export default ConclusionStep
